import { render, staticRenderFns } from "./byline_field.vue?vue&type=template&id=490f8e1a&lang=pug"
import script from "./byline_field.vue?vue&type=script&lang=js"
export * from "./byline_field.vue?vue&type=script&lang=js"
import style0 from "./byline_field.vue?vue&type=style&index=0&id=490f8e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports